/**
 * LoyaltyPointsCard - Highlighted card with the user's loyalty points balance
 */

import { useTranslation } from 'react-i18next';
import { Trophy } from 'lucide-react';

interface LoyaltyPointsCardProps {
  queuePoints: number;
}

export default function LoyaltyPointsCard({ queuePoints }: LoyaltyPointsCardProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-surface border border-hairline rounded-xl p-6 mb-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-ink-subtle uppercase tracking-wide mb-1">{t('profilePage.loyaltyPoints')}</p>
          <p className="text-5xl font-semibold text-ink tabular-nums">{queuePoints}</p>
          <p className={`text-sm mt-2 ${queuePoints >= 0 ? 'text-ink-muted' : 'text-danger'}`}>
            {queuePoints >= 0
              ? t('profilePage.goodBehavior')
              : t('profilePage.recoverPoints')}
          </p>
        </div>
        <Trophy className="w-10 h-10 text-ink-subtle/40" aria-hidden="true" />
      </div>
    </div>
  );
}
